export default function(data, parent, grader) {
  var vm = ko.mapping.fromJS(data);
  vm.allow_save_on_blur = ko.observable(true);
  vm.just_saved = ko.observable(data.just_saved || false);
  vm.editing = ko.observable(false);
  vm.editing = ko.observable(data.editing || false);
  /*----------------------------------------------------VALUE---------------------------------------------------------*/
  vm.old_value = ko.observable(vm.value());
  vm.computed_value = ko.computed({
    read: function () {
      return vm.value();
    },
    write: function (value) {
      var old_value = vm.value();
      if(value.charAt(0) == 0 && value.length > 1){
        value = value.slice(1);
      }
      vm.value(value);
      if (vm.computed_value.isValid() && vm.editing() != 'value') {
        vm.old_value(old_value);
      } else {
        if(value == ''){
          vm.value();
        }
      }
    }
  }).extend({min: 0});

  vm.saveValue = function(silent) {
    if (!isNaN(parseFloat(vm.computed_value())) && vm.computed_value.isValid()) {
      //When changed, mark this grade as overridden if it was auto-graded, if it's an average field, or if it's a group assignment grade for a non-submitting member
      if (vm.autograde() || vm.average() || (grader.coursework().group && grader.coursework().group.joined() && grader.coursework().group.submitted() && !grader.coursework().group.self_submitted())) {
        vm.overridden(true);
      }
      vm.saveGradeEntry(silent).done(function () {
        vm.old_value(vm.value());
      });
      return true;
    }else{
      if(vm.value() === ''){
        vm.overridden(true);
        vm.deleteGradeEntry(silent).done(function () {
          vm.old_value(vm.value());
        });
        return true;
      }
    }
  };

  vm.unlock = function() {
    vm.overridden(false);
    vm.saveGradeEntry().done(function () {
      vm.editing(false);
    });
  };
  /*----------------------------------------------------NOTES---------------------------------------------------------*/
  vm.old_notes = ko.observable(vm.notes());
  vm.computed_notes = ko.computed({
    read: function() {
      return vm.notes();
    },
    write: function(notes) {
      var old_notes = vm.notes();
      vm.notes(notes);
      vm.old_notes(old_notes);
    }
  });

  vm.saveNotes = function(silent) {
    vm.saveGradeEntry(silent).done(function () {
      vm.old_notes(vm.notes());
    });
    return true;
  };

  vm.undo = function() {
    if (vm.editing() == 'value') {
      vm.value(vm.old_value());
    } else if (vm.editing() == 'notes') {
      vm.notes(vm.old_notes());
    }
    vm.editing(false);
  };

  vm.save = function(silent) {
    var success = false;
    if (vm.editing() == 'value') {
      success = vm.saveValue(silent);
    } else if (vm.editing() == 'notes') {
      success = vm.saveNotes(silent);
    }
    if (success) {
      vm.editing(false);
    }
  };
    
  vm.saveOnBlur = function() {
    if (vm.allow_save_on_blur()) {
      vm.save();
    }
  };
  /*----------------------------------------------------PERSISTENCE---------------------------------------------------*/
  vm.updateParentField = function () {
    // This hack is needed to keep the UI in-sync when any changes are made to their grade entry.
    // It is a result of the fact that quiz question VMs were not originally designed to react to live grade entry changes.
    if (grader.coursework().form_builder_type()) {
      var field = _.find(grader.coursework_fields(), function (cf) {
        return cf.id() == parent.id();
      });

      if (field) {
        field.grade_entry.id(vm.id());
        field.grade_entry.value(vm.value());
        field.grade_entry.notes(vm.notes());
        field.grade_entry.overridden(vm.overridden());
        field.grade_entry.editing(vm.editing());
        field.grade_entry.just_saved(vm.just_saved());

        //Re-render the quiz question VM to refresh it
        grader.initFormSubmissionVM(null, field, true);
      }
    }
  };

  vm.saveGradeEntry = function(silent) {
    var deferred = $.Deferred();
    var save = function() {
      var grade_entry_data = {grade_entry: ko.mapping.toJS(vm)};

      var request = new Kadenze.AjaxRequest({
        type: 'POST',
        url: Kadenze.Routes.save_course_gradebook_grade_entries_path(grader.course_id),
        data: grade_entry_data,
        timeout: 60000
      });

      request.done(function(response, status, xhr) {
        vm.id(response.grade_entry.id); //If it's a new grade, update the ID
        vm.just_saved(true);
        vm.updateParentField();
        grader.bindUpdates(response.updates); //Refresh overall state of the grade
        if (silent != true) {
          new Kadenze.Notice.success({});
        }
      });

      request.fail(function(xhr, status, msg) {
        new Kadenze.Notice.error({message: xhr.responseJSON.errors});
      });

      return request;
    };

      //Make sure the parent grade object is persisted first before saving
    grader.grade().getGradeId(true).done(function(grade_id) {
      vm.grade_id(grade_id);
      var response = save();
      deferred.resolve(response);
    });

    return deferred;
  };

  vm.deleteGradeEntry = function () {
    var request = new Kadenze.AjaxRequest({
      type: 'DELETE',
      url: Kadenze.Routes.course_gradebook_grade_entry_path(grader.course_id, vm.id()),
      timeout: 60000
    });

    request.done(function(response, status, xhr) {
      //Reset any properies that could have changed back to their original state
      vm.id(null);
      vm.notes(null);
      vm.value(null);
      vm.overridden(false);
      vm.just_saved(false);

      vm.updateParentField();
      grader.bindUpdates(response.updates); //Refresh overall state of the grade
    });

    request.fail(function(xhr, status, msg) {
      new Kadenze.Notice.error({message: xhr.responseJSON && xhr.responseJSON.errors ? xhr.responseJSON.errors : Kadenze.I18n.t('notice.unexpected_error')});
    });

    return request;
  };
  return vm;
}
